import ProfilePageClient from "@/components/profile/ProfilePageClient";
import { useCurrentProfileQuery } from "@/lib/queries/profileQueries";
import { useRequireAuth } from "@/hooks/useRequireAuth";

export default function ProfilePage() {
  const auth = useRequireAuth();
  const { data: profile, isLoading: profileLoading } = useCurrentProfileQuery();

  if (auth.loading || profileLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#f7f3eb]">
        <p className="text-sm uppercase tracking-[0.28em] text-neutral-600">Loading...</p>
      </div>
    );
  }

  if (!profile) {
    return null;
  }

  return <ProfilePageClient profile={profile} />;
}
